module.exports = __webpack_public_path__ + "img/vacuna.ab62890d.svg";